import DataDefine from './dataDefine';
import DataDefinePriceByDataLevel from './dataDefinePriceByDataLevel';
import DataDefinePriceByReportLevel from './dataDefinePriceByReportLevel';
import DataDefineFrequency from './dataDefineFrequency';
import DataDefineCategory from './dataDefineCategory';
import InsertBuzz from './insertBuzz';
import InsertCampaign from './insertCampaign';
import InsertQuota from './insertQuota';
import InsertUser from './insertUser';
import InsertCategory from './insertCategory';
import InsertIndustry from './insertIndustry';
import ListingBuzz from './listingBuzz';
import ListingUser from './listingUser';
import ListingCampaign from './listingCampaign';
import MigrateData from './migrateData';
import Search from './search';
import AnalysisLevelGuide from './analysisLevelGuide';

export const ROUTES = [
  {
    path: 'data-define-price',
    component: DataDefine,
    role: ['admin'],
  },
  {
    path: 'data-define-price-by-data-level',
    component: DataDefinePriceByDataLevel,
    role: ['admin'],
  },
  {
    path: 'data-define-price-by-report-level',
    component: DataDefinePriceByReportLevel,
    role: ['admin'],
  },
  {
    path: 'data-define-frequency',
    component: DataDefineFrequency,
    role: ['admin'],
  },
  {
    path: 'data-define-category',
    component: DataDefineCategory,
    role: ['admin'],
  },
  {
    path: 'search',
    component: Search,
    role: ['admin', 'line-manager', 'member'],
  },
  {
    path: 'insert-quota',
    component: InsertQuota,
    role: ['admin', 'line-manager', 'member'],
  },
  {
    path: 'list-buzz',
    component: ListingBuzz,
    role: ['admin', 'line-manager'],
  },
  {
    path: 'insert-buzz',
    component: InsertBuzz,
    role: ['admin', 'line-manager'],
  },
  {
    path: 'migrate-data-buzz',
    component: MigrateData,
    role: ['admin'],
  },
  {
    path: 'list-campaign',
    component: ListingCampaign,
    role: ['admin'],
  },
  {
    path: 'insert-campaign',
    component: InsertCampaign,
    role: ['admin'],
  },
  {
    path: 'migrate-data-campaign',
    component: MigrateData,
    role: ['admin'],
  },
  {
    path: 'insert-category',
    component: InsertCategory,
    role: ['admin'],
  },
  {
    path: 'insert-industry',
    component: InsertIndustry,
    role: ['admin'],
  },
  {
    path: 'list-user',
    component: ListingUser,
    role: ['admin'],
  },
  {
    path: 'insert-user',
    component: InsertUser,
    role: ['admin'],
  },
  {
    path: 'analysis-level-guide',
    component: AnalysisLevelGuide,
    role: ['admin', 'line-manager', 'member'],
  },
];

